import React from 'react'
import Icon from '../../../../components/Icon'
import { confirm } from '../../../../components/Dialog'
import Axios from 'axios'
import { useAuth } from '@polvo-labs/react-auth'
import { toast } from 'react-toastify'
import UserType from '../../../../models/User'

interface Props {
  user: UserType
  afterRecover: () => void

}

const RecoveryUser: React.FC<Props> = ({ user, afterRecover }) => {

  const { token } = useAuth()

  return (
    <div>
      <button
        onClick={(evt?: any) => {
          evt.stopPropagation()
          confirm({
            title: 'Confirme',
            message: 'Tem certeza de que deseja recuperar o usuário ' + user.name + '?',
            buttons: [
              {
                label: 'Sim',
                onClick: () => {
                  Axios({
                    method: 'PATCH',
                    url: `${process.env.REACT_APP_API_URL}/users/${user.id}/restore`,
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }).then(({ data }) => {
                    toast.success('Usuário restaurado com sucesso.')
                    afterRecover()
                  }).catch(() => {
                  })
                },
              },
              {
                label: 'Não',
                onClick: () => { },
              },
            ],
          })
        }}
      >
        <Icon
          name="delete-restore"
        />
      </button>
    </div>
  )
}

export default RecoveryUser
